"use client";

import * as React from "react";
import { Briefcase, Handshake, Headset, Mail, MessageSquare, Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const supportChannels = [{
  id: "projects",
  title: "Drywall & Painting",
  description: "Expert installation, repair, and professional interior or exterior finishes for your home.",
  icon: Briefcase,
  email: "smith3bgroupllc@gmail.com",
  phone: "954-681-5265"
}, {
  id: "maintenance",
  title: "Property Care",
  description: "Pressure cleaning, faucet installation, and toilet or vanity replacement services.",
  icon: Headset,
  email: "smith3bgroupllc@gmail.com",
  phone: "954-681-5265"
}, {
  id: "demo",
  title: "Demo & Hauling",
  description: "Professional residential demolition, project management, and efficient debris removal.",
  icon: Handshake,
  email: "smith3bgroupllc@gmail.com",
  phone: "954-681-5265"
}];
const faqs = [{
  id: "faq-1",
  question: "WHAT AREAS DO YOU COVER FOR PRESSURE CLEANING?",
  answer: "We provide professional pressure cleaning for driveways, roofs, and home exteriors throughout our service area, ensuring a pristine finish every time."
}, {
  id: "faq-2",
  question: "HOW DO I REQUEST A PROJECT ESTIMATE?",
  answer: "Simply reach out via phone or email. We offer free assessments for drywall, painting, and demolition projects to provide accurate and transparent pricing."
}, {
  id: "faq-3",
  question: "DO YOU HANDLE FULL BATHROOM FIXTURES?",
  answer: "Yes, we specialize in the installation of toilets, vanities, and faucets as part of our comprehensive interior maintenance and renovation services."
}];
export default function GlobalSupportHub() {
  return <section data-section-id="114944" id="start-your-project" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="text-3xl font-default uppercase tracking-tighter md:text-4xl lg:text-5xl">
            READY TO START?
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg font-sans">
            Connect with SMITH & B GROUP LLC for architectural precision in construction and maintenance. Reach us at smith3bgroupllc@gmail.com or 954-681-5265.
          </p>
        </div>

        <div className="mb-16 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {supportChannels.map((channel, i) => {
          const Icon = channel.icon;
          return <Card key={channel.id} data-index={i} className="flex flex-col justify-between transition-colors hover:border-primary border-border bg-card rounded-sm shadow-none">
                <div>
                  <CardHeader>
                    <div className="bg-primary/10 mb-4 inline-flex size-12 items-center justify-center rounded-sm">
                      <Icon className="text-primary size-6" />
                    </div>
                    <CardTitle className="text-xl font-default uppercase">{channel.title}</CardTitle>
                    <CardDescription className="mt-2 text-base font-sans">
                      {channel.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="flex flex-col gap-3">
                    <div className="flex items-center gap-3 text-sm font-mono">
                      <Mail className="text-muted-foreground size-4 shrink-0" />
                      <Link to={`mailto:${channel.email}`} className="hover:text-primary transition-colors">
                        {channel.email}
                      </Link>
                    </div>
                    <div className="flex items-center gap-3 text-sm font-mono">
                      <Phone className="text-muted-foreground size-4 shrink-0" />
                      <Link to={`tel:${channel.phone.replace(/[^0-9+]/g, "")}`} className="hover:text-primary transition-colors">
                        {channel.phone}
                      </Link>
                    </div>
                  </CardContent>
                </div>
                <CardFooter>
                  <Button className="w-full gap-2 bg-primary text-primary-foreground rounded-sm font-default uppercase hover:opacity-90 transition-opacity" variant="default">
                    <Phone className="size-4" />
                    Quick Call
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>

        <div className="mx-auto max-w-3xl">
          <div className="mb-8 text-center">
            <h3 className="text-2xl font-default uppercase tracking-tight">PROJECT FAQ</h3>
            <p className="text-muted-foreground mt-2 font-sans">
              Common questions about our construction and hauling services.
            </p>
          </div>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border">
                <AccordionTrigger className="text-base font-default uppercase text-left hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}